import React from 'react';
import { Heart, Mail } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Footer = ({ activeView, setActiveView }) => {
  const currentYear = new Date().getFullYear();

  const handleNavigation = (viewId) => {
    if (setActiveView) {
      setActiveView(viewId);
    }
  };

  return (
    <footer className="bg-black text-white border-t-2 border-white">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Section 1: À propos */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Crewmate
            </h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              Your breaking training companion. Organize your moves, track your progress, and improve your skills.
            </p>
            <div className="flex items-center text-sm text-gray-400">
              <Heart className="w-4 h-4 mr-2 text-red-500" />
              Made with passion for the breaking community
            </div>
          </div>

          {/* Section 2: Navigation rapide */}
          <div className="space-y-4">
            <h4 className="text-md font-semibold text-white">Navigation</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <button 
                  onClick={() => handleNavigation('home')}
                  className="hover:text-white transition-colors text-left"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('encyclopedia')}
                  className="hover:text-white transition-colors text-left"
                >
                  Arsenal
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('crews')}
                  className="hover:text-white transition-colors text-left"
                >
                  Crews
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('routines')}
                  className="hover:text-white transition-colors text-left"
                >
                  Routines
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('shuffle')}
                  className="hover:text-white transition-colors text-left"
                >
                  Mixer
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('transitions')}
                  className="hover:text-white transition-colors text-left"
                >
                  Transitions
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('revision')}
                  className="hover:text-white transition-colors text-left"
                >
                  Revision
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('customize')}
                  className="hover:text-white transition-colors text-left"
                >
                  Studio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigation('profile')}
                  className="hover:text-white transition-colors text-left"
                >
                  Profile
                </button>
              </li>
            </ul>
          </div>

          {/* Section 3: Liens utiles */}
          <div className="space-y-4">
            <h4 className="text-md font-semibold text-white">Contact</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <a 
                  href="mailto:sylvain.davenel.pro@gmail.com" 
                  className="flex items-center hover:text-white transition-colors"
                >
                  <Mail className="w-4 h-4 mr-2" />
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Barre de séparation */}
        <div className="mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © {currentYear} Crewmate. Tous droits réservés.
            </div>
            <div className="flex space-x-6 text-sm text-gray-400">
              <button className="hover:text-white transition-colors">
                Confidentialité
              </button>
              <button className="hover:text-white transition-colors">
                Conditions d'utilisation
              </button>
              <button className="hover:text-white transition-colors">
                Cookies
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 